import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.6 8.8c-.067 0-.067-.067-.133-.067C11.467 8 12 6.867 12 5.6v-.467l.2-1.6c.133-1.066-.6-2-1.6-2.2L10 1.2q-2-.3-4 0l-.533.133c-1.067.2-1.8 1.134-1.667 2.2l.2 1.6V5.6c0 1.2.533 2.4 1.533 3.133-.066 0-.066.067-.133.067-2.2.933-3.733 3-4 5.4-.067.333.2.667.6.733.4.067 11.667 0 12 0h.067c.333-.066.6-.4.6-.733-.334-2.4-1.867-4.467-4.067-5.4M8 10.867 6.867 9.733a6.1 6.1 0 0 1 2.2 0zm0-2.6c-1.467 0-2.6-1.134-2.667-2.6h5.334c-.067 1.466-1.2 2.6-2.667 2.6"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })